// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

var thumbsp = new Swiper("#thumbs-p", {
  direction: "vertical",
  spaceBetween: 23,
  slidesPerView: 3,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper = new Swiper("#swiper-p1", {
  thumbs: {
    swiper: thumbsp,
  },
  on: {
    slideChange: function (e) {
      $("#sp-color .option")
        .eq(e.activeIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  spaceBetween: 20,
});
$(function () {
// 处理加入购物车事件
function handleAddToCart(num) {
  if (num > 0) {
    $("#cardNum").html(num).show();
    $(".sp-top-btn").addClass("sp-high");
    $(".sp-top-btn span").html("Check out");
    $(".sp-header-top .sp-cart").addClass("on");
  } else {
    $("#cardNum").html(0).hide();

    $(".sp-top-btn").removeClass("sp-high");
    $(".sp-top-btn span").html("Buy now");
    $(".sp-header-top .sp-cart").removeClass("on");
  }
}
handleAddToCart(window.cartCount);

let prods = window.product

function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price / 100).toFixed(2)
  let compare = (getCur().compare_at_price / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  $('.product-part .price-group .price1 span').html(price)
  $('.product-part .price-group .price2 span').html(compare)
  // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .brand .num").html(off_font);
}

$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  // window.location.href = '/cart/' + getCur().id + ':' + num
})
// 弹窗 start
   var main_id = "";
    $('.emitCheckout').click(function(){
      console.log('1111')
      main_id = getCur().id
      // main_id = $(this).siblings('.select_span').find('span.on').data('id')
      // window.location.href = "/cart/" + id + ":1"
    })

  function getPopProdId(){
    let selectVals = [];
   $('.overbuy_wrap .sp-subopt.active').each(function(){
      selectVals.push($(this).data('val'))
    })

    let cur = popProduct.filter(item => {
      let option1 = selectVals[0];
      let option2 = null;
      let option3 = null;
      if(selectVals[1]){
        option2 = selectVals[1];
      }
      if(selectVals[2]){
        option3 = selectVals[2];
      }

      
      return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
    })

 
    
    return cur[0];
  }

  $('.overbuy-select div').click(function(){
     $(this).siblings().removeClass('active')
     $(this).addClass('active')
    let cur = getPopProdId();
    
    if(cur){
      $(".main-btn").text('GET 10% oFF').removeClass("overbuy_disabled")
      let _price = parseFloat(cur.price / 100).toFixed(2);
      let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2);
  
      $('.overbuy_price span').eq(0).html('$' + _price);
      $('.overbuy_price span').eq(1).html('$' + _compare_at_price);
    }else{
      $(".main-btn").text("Unavailable").addClass("overbuy_disabled")
    }
    
  })

  


  window.emitSubmit = function(_type){
    let num = $('#calcNumber').val()
     if(_type == 'all'){
      // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
      let _id = getPopProdId()?.id;
       if(!_id) return
      console.log(_id)
       
      window.location.href = `/cart/${main_id}:${num},${_id}:1`
    }else{
      window.location.href = `/cart/${main_id}:${num}`
    }
  }



  // 弹窗 end

$('.sp-header-top .sp-top-btn').click(function(){
  $.ajax({
    type: "POST",
    url: "/cart/",
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        let cartNum = result.item_count
        let cartItem = result.items
        let url = '/cart/'
        if(cartNum > 0){
          cartItem.forEach(function(cartItem) {
              url += cartItem.id + ':' + cartItem.quantity + ','
          });
          window.location.href =  url
        }
      });
    },
    dataType: "json",
  });
})

$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
});

// 商品弹窗状态
let _popShow = false;

// 展示尺码弹窗
$(".sp-size-btn").click(function () {
  $(".sp-mask").css("display", "flex");
  $(".sp-mask .size-pop").show();
  $(".sp-mask .img-pop").hide();
});

// 点击页面内尺码表
$(".sp-size-part .sp-img").click(function () {
  $(".sp-mask").css("display", "flex");
  $(".sp-mask .img-pop .sp-img")[0].src = $(this)[0].src;

  $(".sp-mask .img-pop").css("display", "flex");
  $(".sp-mask .size-pop").hide();
});

// 关闭弹窗按钮
$(".close-btn, .sp-close-pop").click(function () {
  $(".sp-mask").hide();
  // $(".sp-mask2").hide();
});

$(".sp-mask").click(function (e) {
  if ($(e.target).closest(".sp-mask .choose-btn").length > 0) {
  } else {
    $(".sp-mask").hide();
  }
});

let spImgList = [
  "https://cdn.shopifycdn.net/s/files/1/0653/7923/8101/files/20240524-p-green.png",
  "https://cdn.shopifycdn.net/s/files/1/0653/7923/8101/files/20240524-p-beige.png",
  "https://cdn.shopifycdn.net/s/files/1/0653/7923/8101/files/20240524-p-black.png",
  "https://cdn.shopifycdn.net/s/files/1/0653/7923/8101/files/20240524-p-blue.png",
  "https://cdn.shopifycdn.net/s/files/1/0653/7923/8101/files/20240524-p-more.png",
];
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let style = $('#sp-style div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == style)[0]
}

  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项
    let colorOptions = $("#sp-color .option.active").index();
    swiper.slideTo(colorOptions);
    changePrice()
  });

  // style选项
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
  });
  
  $(".product-part .cart-btn").click(function () {
    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
          handleAddToCart(result.item_count);
        });
      },
      dataType: "json",
    });

    var img = $(".product-part .sp-swiper .swiper-slide-active img");

    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      background: "#e7e9ef",
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop,
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });
});

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") +
            -280 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
    $(".input_number").css("font-size", "20px");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();
